import React from 'react';
import { Stack } from '@mui/material';
import { theme } from '../../styles/theme';
import { Text } from '../Text/Text';
import { LANGMAGIC_APPS } from '../../constants';

const linkStyle: React.CSSProperties = {
    color: 'inherit',
    fontWeight: 500,
};

export const Footer: React.FC = () => (
    <Stack
        className={'footer'}
        direction={'row'}
        flexWrap={'wrap'}
        justifyContent={'center'}
        alignItems={'center'}
        columnGap={1.5}
        sx={{
            py: theme.spacing(.5),
            mt: 'auto',
            color: theme.palette.grey[700],
            fontSize: '11px',
        }}
    >
        <Text
            sx={{
                color: 'inherit',
                fontSize: 'inherit',
                fontWeight: 300,
            }}
        >
            Powered by{' '}
            <a
                href={'https://langmagic.com'}
                style={linkStyle}
            >
                Langmagic
            </a>
        </Text>

        <Text
            sx={{
                color: 'inherit',
                fontSize: 'inherit',
                fontWeight: 300,
            }}
        >
            :
        </Text>

        {LANGMAGIC_APPS.map(app => (
            <a
                key={app.title}
                href={app.url}
                target={'_blank'}
                rel={'noopener'}
                style={linkStyle}
            >
                {app.title}
            </a>
        ))}
    </Stack>
);
